import { Injectable } from '@angular/core';
import { CustomSupervisionApi } from '../../api/custom-supervision/custom-supervision.api';
import { AssignmentsRequestDTO } from '../../model/assignments/assignments-request-dto.model';
import { PagedModel } from '../../model/base/paged.model';
import { CustomSupervisionAssignmentRequest } from '../../model/custom-supervision/custom-supervision-assignment-request.model';

@Injectable()
export class CustomSupervisionService {

    constructor(
        private customSupervisionApi: CustomSupervisionApi
    ) { }

    getAssignments = (assignmentRequest: AssignmentsRequestDTO) => this.customSupervisionApi.getAssignments(assignmentRequest);

    getRolesICanManage = () => this.customSupervisionApi.getRolesICanManage();
    
    getAllMyEmployeeIds = () => this.customSupervisionApi.getAllMyEmployeeIds();

    getMyEmployeeAssignments = (paging: PagedModel) => this.customSupervisionApi.getMyEmployeeAssignments(paging);

    /**
     * Returns a list of roles that given user can have as target peers
     * @param userId 
     * @returns List of PAETEPRoleType
     */
    getRolesUserCanSupervise = (userId: string) => this.customSupervisionApi.getRolesUserCanSupervise(userId);

    addAssignment = (assignment: CustomSupervisionAssignmentRequest) => this.customSupervisionApi.addAssignment(assignment);

    removeAssignment = (assignment: CustomSupervisionAssignmentRequest) => this.customSupervisionApi.removeAssignment(assignment);
}
